module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "lxm-nav-container"
  }, [_c('nav', {
    staticClass: "level is-mobile lxm-nav"
  }, [_c('p', {
    staticClass: "level-item has-text-left lxm-nav__left"
  }, [_c('img', {
    staticClass: "lxm-nav__left-img",
    attrs: {
      "src": require("../../images/main/nav-back.png")
    },
    on: {
      "click": _vm.backClicked
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "lxm-transition-fade",
      "mode": "out-in"
    }
  }, [(_vm.title) ? [_c('p', {
    staticClass: "level-item has-text-centered lxm-nav__title"
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n          ")])] : [_c('lxm-search', {
    on: {
      "click": _vm.searchClicked,
      "submit": _vm.searchSubmitted,
      "input": _vm.searchInputted
    }
  })]], 2), _vm._v(" "), _c('p', {
    staticClass: "level-item has-text-right lxm-nav__right"
  }, [_c('transition', {
    attrs: {
      "name": "lxm-transition-small",
      "mode": "out-in"
    }
  }, [(_vm.share) ? [_c('img', {
    staticClass: "lxm-nav__right-img",
    attrs: {
      "src": require("../../images/main/nav-share.png")
    },
    on: {
      "click": _vm.shareClicked
    }
  })] : _vm._e(), _vm._v(" "), (_vm.menu) ? [_c('img', {
    staticClass: "lxm-nav__right-img lxm-nav__right-img--menu",
    attrs: {
      "src": require("../../images/main/menu-red.png")
    },
    on: {
      "click": _vm.menuClicked
    }
  })] : _vm._e(), _vm._v(" "), (_vm.qrcode) ? [_c('img', {
    staticClass: "lxm-nav__right-img lxm-nav__right-img--qrcode",
    attrs: {
      "src": require("../../images/main/nav-qrcode.png")
    }
  })] : _vm._e()], 2)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "lxm-nav-placeholder"
  }), _vm._v(" "), _c('lxm-menu-panel', {
    ref: "menuPanel"
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c66dc89c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c66dc89c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/common/LxmNav.vue
// module id = 887
// module chunks = 0